function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "community-gradient_svg__b",
  x1: 0.561,
  y1: 1,
  x2: 0.722,
  y2: 0.337,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a1dbd3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.472,
  stopColor: "#c4f0ea",
  stopOpacity: 0.937
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a1dbd3",
  stopOpacity: 0.333
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "community-gradient_svg__c",
  x1: 0.561,
  y1: 1,
  x2: -0.004,
  y2: -0.418,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a1dbd3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.414,
  stopColor: "#e8f6f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a1dbd3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "community-gradient_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1452",
  transform: "translate(6338 3439)",
  fill: "#fff",
  opacity: 0.996,
  d: "M0 0h1366v1359H0z"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 5",
  transform: "translate(-6338 -3439)",
  opacity: 0.5,
  clipPath: "url(#community-gradient_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1959",
  d: "M1335.1-6.427c6.673 0 81.968-207.319 88.054-206.205 163.381 29.888 123.306 643.905 123.306 788.113 0 149.749-1368.412 668.807-1548.77 668.807S-22.7 565.708-22.7 415.959 1154.741-6.427 1335.1-6.427z",
  transform: "rotate(85 1616.424 5795.525)",
  fill: "url(#community-gradient_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1960",
  d: "M29.745-1.637c166.7 3.487 836.261 370.435 827.5 674.8s620.924 1041.948 454.228 1038.462-939.81 79.915-931.05-224.455S-136.951-5.123 29.745-1.637z",
  transform: "translate(6888.7 3254.556)",
  fill: "url(#community-gradient_svg__c)"
})));
var SvgCommunityGradient = function SvgCommunityGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 1359
  }, props), _ref, _ref2);
};
export default SvgCommunityGradient;